import { AppState } from '../helper';

// eslint-disable-next-line import/prefer-default-export
export const selectIsEducatorsAppEnabled = (state: AppState) => !!state.remoteConfig.educatorsAppURL;
